"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useInputForm_1 = require("../../hooks/useInputForm");
const Checkbox_1 = __importDefault(require("./Checkbox"));
const helpers_1 = require("../../lib/helpers");
const useToggleableChange_1 = require("../../hooks/useToggleableChange");
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const RadioInput_1 = require("./RadioInput");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const InputLabel_1 = require("./Base/InputLabel");
const CheckboxInput = (props) => {
    const { children, uncheckedValue = false, checkedValue = true } = props;
    const onChange = useInputForm_1.useInputFormChange(props);
    const toggleableProps = useToggleableChange_1.useToggleableChange(onChange, props.onClick, props.disabled);
    const isChecked = RadioInput_1.useInputChecked(props);
    const label = InputLabel_1.getInputLabel(props.label, props.name);
    return (react_1.default.createElement(InputDiv_1.default, Object.assign({ value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error }, toggleableProps),
        react_1.default.createElement(Checkbox_1.default, Object.assign({}, helpers_1.without(props, ['className', 'onClick', 'onTouchStart']), { checkedValue: checkedValue, uncheckedValue: uncheckedValue, checked: isChecked })),
        label && react_1.default.createElement("span", { className: "j-checkbox-input-label" }, label),
        children,
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-checkbox-input', CheckboxInput);
